import { render } from "./SellMessage.vue?vue&type=template&id=0a1839c2&scoped=true&ts=true"
import script from "./SellMessage.vue?vue&type=script&lang=ts"
export * from "./SellMessage.vue?vue&type=script&lang=ts"

import "./SellMessage.vue?vue&type=style&index=0&id=0a1839c2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1839c2"]])

export default __exports__